import { useModuleBEM } from "@b2bportal/core-themes";
import type { Product } from "@b2bportal/purchase-api";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { Checkbox } from "@tenant/ui";
import { useTravelCreditSelection } from "./hooks/useTravelCreditSelection";
import styles from "./styles.module.scss";

export const TravelCreditsSelection = ({ product }: { product?: Product }) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "TravelCreditsSelection");

  const {
    context: {
      creditSelected,
      isCreditSelectionDisabled,
      travelCreditBalance,
      travelCreditPayAmount,
    },
    handlers: { onCheckboxClick },
  } = useTravelCreditSelection(product);

  return (
    <div className={block}>
      <h3 className={cn("header")}>{t("travelCredits.title")}</h3>

      <div
        className={cn("container", {
          selected: creditSelected,
          disabled: isCreditSelectionDisabled,
        })}
      >
        <span className={cn("credits")}>
          {creditSelected ? (
            <Trans
              i18nKey="travelCredits.payAmountAndBalance"
              components={[<span className={cn("price")} />]}
              values={{
                price: travelCreditPayAmount,
                balance: travelCreditBalance,
              }}
            />
          ) : (
            travelCreditBalance
          )}
        </span>

        <div className={cn("description")}>
          <span>{t("travelCredits.description")}</span>
          <Checkbox checked={creditSelected} onClick={onCheckboxClick} />
        </div>
      </div>
    </div>
  );
};
